function secureRandomInt(max) {
  const array = new Uint8Array(1);
  const limit = Math.floor(256 / max) * max;

  let value;

  do {
    window.crypto.getRandomValues(array);
    value = array[0];
  } while (value >= limit);

  return value % max;
}

function getLuhnCheckDigit(numberWithoutCheckDigit) {
  const digits = numberWithoutCheckDigit
    .split("")
    .reverse()
    .map((digit) => Number(digit));

  const sum = digits.reduce((total, digit, index) => {
    let value = digit;

    if (index % 2 === 0) {
      value *= 2;

      if (value > 9) {
        value -= 9;
      }
    }

    return total + value;
  }, 0);

  return String((10 - (sum % 10)) % 10);
}

export function generateCardNumber() {
  const digits = [];

  // First digit should not be 0
  digits.push(String(secureRandomInt(9) + 1));

  // 15 total digits before check digit
  for (let i = 1; i < 15; i += 1) {
    digits.push(String(secureRandomInt(10)));
  }

  const baseNumber = digits.join("");
  const checkDigit = getLuhnCheckDigit(baseNumber);

  return `${baseNumber}${checkDigit}`;
}